import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { RenderDynamicDirective, provideDynamicComponents } from './dynamic-components-loader.service';

@Component({
    selector: 'ms-dynamic-icon',
    imports: [RenderDynamicDirective],
    template: `<span msRenderDynamic [innerHTML]="parsedHtml()"></span>`,
    providers: [provideDynamicComponents([{ selector: 'vn-icon', componentType: IconCustomComponent }])],
})
export class DynamicIconComponent {
    html = input.required<string>();
    sanitizer = inject(DomSanitizer);

    parsedHtml = computed(() => {
        return this.sanitizer.bypassSecurityTrustHtml(this.html());
    });
}
